export const isPositiveIntegerText = (value) => /^[1-9]\d*$/.test(String(value ?? ''));

export const normalizePlannedRoundCount = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= 1 ? parsed : 1;
};

export const formatPlannedRoundLabel = (value) => {
  const plannedRoundCount = normalizePlannedRoundCount(value);
  return plannedRoundCount === 1 ? '単発予定' : `全${plannedRoundCount}ラウンド予定`;
};
